// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modalBackgorund_wrapper__1xgNz","content":"modalBackgorund_content__2jRbv","closeX":"modalBackgorund_closeX__3kS6b"};